import ReportEditKeyTakeaways from './reportEditKeyTakeaways'
export default ReportEditKeyTakeaways
